import { useNavigate } from "react-router-dom"
import SummerYouAltLogo from "../../assets/summeryou-alt-logo.png"
import { useEffect } from "react";

const SuccessPage = () => {
    const navigate = useNavigate();

    useEffect(() => {
        document.title = "Welcome Abroad! - SummerYou";
        const timer = setTimeout(() => {
      navigate("/signIn"); // target route
    }, 5000); // 5 seconds delay

    return () => clearTimeout(timer);
  }, [navigate]);    

    return (
        <>
            <div className="flex min-h-full flex-1 flex-col justify-center py-7 px-6 sm:px-6 lg:px-8 font-inter">
                <div className="sm:mx-auto sm:w-full sm:max-w-md">
                    <img src={SummerYouAltLogo} className="animate-spin-slow w-24 h-24 mx-auto"></img>

                    <h2 className="mt-3 text-center text-xl font-bold leading-9 tracking-tight text-gray-900">
                        Welcome aboard!
                    </h2>
                    <p className="text-justify text-sm mt-2">
                        Your account has been created successfully. You will be automatically redirected to the login page to start exploring.
                    </p>
                    <p className="text-justify text-sm mt-2">
                        <a className="underline decoration-dotted cursor-pointer" onClick={() => { navigate("/signIn") }}>Click here to go now <span>↗</span></a>
                    </p>
                </div>
            </div>
        </>
    )
}

export default SuccessPage;